import React from "react"

const SectionChallenges = () => (
  <section className="chal-sec">
    <div className="wrap">
      <h2>What makes TEAM hard</h2>
      <div className="chal">
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 4 4 10l12 6 12-6z" />
              <path d="M4 16l12 6 12-6" />
              <path d="M4 22l12 6 12-6" />
            </svg>
          </div>
          <b>Five service lines</b>
          <span>Each needs its own plan.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M13 5H6v22h7" />
              <path d="M19 10l6 6-6 6" />
              <path d="M25 16H12" />
            </svg>
          </div>
          <b>Care after discharge</b>
          <span>Much of the cost sits outside your walls.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="16" cy="16" r="11" />
              <path d="M16 10v6l4 3" />
            </svg>
          </div>
          <b>Late results</b>
          <span>Claims arrive months after the episode.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 4l3.6 7.4 8.1 1.1-5.9 5.7 1.4 8.1L16 22.4l-7.2 3.9 1.4-8.1-5.9-5.7 8.1-1.1z" />
            </svg>
          </div>
          <b>Quality moves payment</b>
          <span>Your score adjusts what you earn or owe.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 4l10 4v7c0 6.5-4.3 11-10 13-5.7-2-10-6.5-10-13V8z" />
              <path d="M16 11v6" />
              <path d="M16 21v.5" />
            </svg>
          </div>
          <b>Downside risk in 2027</b>
          <span>Most hospitals move to two-sided risk.</span>
        </div>
      </div>
    </div>
  </section>
)

export default SectionChallenges
